export class Township {
  code?: string;
  name?: string;
}
